// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1NhA5","topBottomGutter":"Layout_topBottomGutter__1J-vq"};